export default "__VITE_ASSET__bCvEhzLF__"